import Api from "@root/components/api";

export default class CardListMutation {
    async load() {
        let query = `query {
            currentUser {    
                cardLists {
                    id, name, description, cardCount, gameCount, usersCount
                    primarySubject {id, name}
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query });
        if (result.errors) {
            return;
        }

        return result.data.currentUser?.cardLists;        
    }
    
    async loadUserLists() {
        let query = `query {
            currentUser {    
                userCardLists {
                    id, name, description, skillCount, dueSkillCount, dueTomorrowSkillCount, studyCount
                    primarySubject {id, name}
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query });
        if (result.errors) {
            return;
        }

        return result.data.currentUser?.userCardLists;        
    }
   
    async loadUserListsWithLinks() {
        let query = `query {
            currentUser {    
                cardListsWithSource {
                    linkId
                    list { 
                        id name description skillCount dueSkillCount dueTomorrowSkillCount studyCount
                        primarySubject {id name}
                    }
                    team {
                        id name
                    }
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query });
        if (result.errors) {
            return;
        }

        return result.data.currentUser?.cardListsWithSource;        
    }
    
    async loadGameCard(listId, teamId) {
        let query = `query($id: String!, $teamId: String!) {
            cardList(id: $id) {
                id, name, my
                workouts {
                    id seed
                    skill {
                        id, name
                    }
                    card {
                        id, name
                    }
                    grasp {
                        remindAt knowledgeLevel study
                    }
                    grasps(teamId: $teamId, listId: $id) {
                        remindAt knowledgeLevel study userId averageTime speedLevel
                    }
                    game {
                        id, name, answerType, imageUrl, gameUrl,
                        autoCheck, count, gameType, time, language, requirements,
                        authorId, authorName, authorAvatar, public, likes, canLike,
                        primarySkill {
                            id, name, iknow, exercisePoints,
                            primarySubject { id, name }
                        },
                        fieldSets { id },
                        authorId, authorName,
                        skills { id, name, iknow }
                    }
                }
                students(teamId: $teamId) { 
                    id owner manager
                    user { id visualName }                    
                }
            }            
        }`;
        let result = await Api.postData('/g', { query: query, variables: {
            id: listId,
            teamId: teamId,
        } });
        if (result.errors) {
            return;
        }
        return result.data.cardList;        
       
    }
    
    async loadCardsOld(listId) {
        let query = `query($id: String!) {
            cardList(id: $id) {
                id name description study cardCount gameCount my canEdit published
                primarySubject {id, name}
                userProgress {
                    user {
                        id shortName
                    }
                    grasps {
                        workoutId knowledgeLevel speedLevel
                    }
                }
                workouts {
                    id seed
                    skill {
                        id, name, iknow, study, remindAt
                    }
                    card {
                        id, name, 
                        skill {
                            id, name, iknow, study, easyFactor, repetition, interval, remindAt
                        }
                        template { name }
                    }
                    game {
                        id, name, answerType, imageUrl, gameUrl,
                        autoCheck, count, gameType, time, language, requirements,
                        authorId, authorName, authorAvatar, public, likes, canLike,
                        primarySkill {
                            id, name, iknow, exercisePoints,
                            primarySubject { id, name }
                        },
                        fieldSets { id },
                        authorId, authorName,
                        skills { id, name, iknow }
                    }
                    grasp {
                        remindAt knowledgeLevel study
                    }
                }
                cards {
                    id, name, 
                    skill {
                        id, name, iknow, study, easyFactor, repetition, interval, remindAt
                    }
                    template {
                        fieldSets {
                            id
                        }
                    }
                }
                games {
                    id, name, answerType, imageUrl, gameUrl,
                    autoCheck, count, gameType, time, language, requirements,
                    authorId, authorName, authorAvatar, public, likes, canLike,
                    primarySkill {
                        id, name, iknow, exercisePoints,
                        primarySubject { id, name }
                    },
                    fieldSets { id },
                    authorId, authorName,
                    skills { id, name, iknow }
                }
                compatibleGames {
                    id, name, answerType, imageUrl, 
                    autoCheck, count, gameType, time, language, requirements,
                    authorId, authorName, authorAvatar, public, likes, canLike,
                    primarySkill {
                        id, name, iknow, exercisePoints,
                        primarySubject { id, name }
                    },
                    authorId, authorName,
                    skills { id, name, iknow }
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query, variables: {id: listId} });
        if (result.errors) {
            return;
        }
        return result.data.cardList;        
    }
    
    async loadCards(listId) {
        let query = `query($id: String!) {
            cardList(id: $id) {
                id name description study cardCount gameCount my canEdit published
                primarySubject {id, name}
                userProgress {
                    user {
                        id shortName
                    }
                    grasps {
                        workoutId knowledgeLevel speedLevel
                    }
                }
                cards {
                    id, name, 
                    skill {
                        id, name, iknow, study, easyFactor, repetition, interval, remindAt
                    }
                    myGrasps {
                        stage quality speedLevel knowledgeLevel
                        workout {
                            seed
                            game { id }
                        }
                    }
                    template {
                        name
                        fieldSets {
                            id
                        }
                    }
                }
                games {
                    id, name, answerType, imageUrl, gameUrl,
                    autoCheck, count, gameType, time, language, requirements,
                    authorId, authorName, authorAvatar, public, likes, canLike, isMultiExercise
                    primarySkill {
                        id, name, iknow, exercisePoints,
                        primarySubject { id, name }
                    },
                    fieldSets { id },
                    authorId, authorName,
                    skills { id, name, iknow }
                }
                compatibleGames {
                    id, name, answerType, imageUrl, 
                    autoCheck, count, gameType, time, language, requirements,
                    authorId, authorName, authorAvatar, public, likes, canLike, isMultiExercise
                    primarySkill {
                        id, name, iknow, exercisePoints,
                        primarySubject { id, name }
                    },
                    authorId, authorName,
                    skills { id, name, iknow }
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query, variables: {id: listId} });
        if (result.errors) {
            return;
        }
        return result.data.cardList;        
    }
    
    async loadNoListCards() {
        let query = `query {
            noCardList {
                id, name
                cards {
                    id, name
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query });
        if (result.errors) {
            return;
        }
        return result.data.noCardList;
    }

    async loadTemplates() {
        let query = `query {
            currentUser {    
                cardTemplates {
                    id, name, cardCount
                    fieldSets {
                        name
                        fields {
                            name, type,
                            i18n, multi, cardTemplateId
                        }
                    }
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query });
        if (result.errors) {
            return;
        }

        return result.data.currentUser?.cardTemplates;        
    }
    
    async save(cardList) {
        let query = `mutation ($input: CardListInput!) {
            saveCardList(input: $input)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            input: {
                id: cardList.id,
                name: cardList.name ?? "", 
                primarySubjectId: cardList.primarySubject?.id,
                description: cardList.description,
            }
        }});
    } 
   
    async remove(id) {
        let query = `mutation ($id: String!) {
            removeCardList(id: $id)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            id: id
        }});
    } 
  
    async publishCardList(id, published) {
        let query = `mutation ($id: String!, $published: Boolean!) {
            publishCardList(cardListId: $id, published: $published)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            id: id, published: published
        }});
    } 
       
    async reorderWorkouts(cardListId, ids) {
        let query = `mutation ($cardListId: String!, $ids: [String!]!) {
            reorderWorkouts(cardListId: $cardListId, ids: $ids)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            cardListId: cardListId,
            ids: ids
        }});
    } 
  
    async addGame(cardListId, gameId) {
        let query = `mutation ($cardListId: String!, $gameId: String!) {
            addCardListGame(cardListId: $cardListId, gameId: $gameId)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            cardListId: cardListId,
            gameId: gameId,
        }});
    } 
  
    async removeGame(cardListId, gameId) {
        let query = `mutation ($cardListId: String!, $gameId: String!) {
            removeCardListGame(cardListId: $cardListId, gameId: $gameId)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            cardListId: cardListId,
            gameId: gameId,
        }});
    } 
 
    async addUserCardList(cardListId) {
        let query = `mutation ($cardListId: String!) {
            addUserCardList(cardListId: $cardListId)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            cardListId: cardListId,
        }});
    } 

    async removeUserCardList(cardListId) {
        let query = `mutation ($cardListId: String!) {
            removeUserCardList(cardListId: $cardListId)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            cardListId: cardListId,
        }});
    } 
    
    async createCard(listId, templateId) {
        let query = `mutation ($listId: String!, $templateId: String!) {
            saveCard(listId: $listId, templateId: $templateId) {
                id
            }
        }`;
        const result = await Api.postData('/g', { query: query, variables: {
            listId: listId,
            templateId: templateId,
        }});
        return result.data?.saveCard;
    } 
    
    async loadGame(listId) {
        let query = `query($id: String!) {
            cardList(id: $id) {
                id, name
                next
            }
        }`;
        let result = await Api.postData('/g', { query: query, variables: {id: listId} });
        if (result.errors) {
            return;
        }
        return result.data.cardList;        
    }   

    async generateWorkouts(listId) {
        let query = `mutation($id: String!) {
            generateWorkouts(cardListId: $id)
        }`;
        let result = await Api.postData('/g', { query: query, variables: {id: listId} });
        if (result.errors) {
            return;
        }
        return result.data.generateWorkouts;        
    }

    async getCards(gameId, cardListId, count) {
        let result = await Api.postData('/api/getGameCards', {
            gameId: gameId, cardListId: cardListId, count: count
        }); 
        return result;
    }
}